import grade from '@/api/grade'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  edit_data: {},
  main_programs: [],
  core_programs: [],
  ignore_cycle: [],
  score_type: [],
  monthly_score_sc_bas_id: [],
  semester_score_sc_bas_id: [],
  is_active: ['0', '1'],
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_EDIT_DATA(state, data) {
    state.edit_data = data
  },
  SET_MAIN_PROGRAMS(state, main_programs) {
    state.main_programs = main_programs
  },
  SET_CORE_PROGRAMS(state, core_programs) {
    state.core_programs = core_programs
  },
  SET_IGNORE_CYCLES(state, data) {
    state.ignore_cycle = data
  },
  SET_SCORE_TYPE(state, data) {
    state.score_type = data
  },
  SET_MONTHLY_SCORE(state, data) {
    state.monthly_score_sc_bas_id = data
  },
  SET_SEMESTER_SCORE(state, data) {
    state.semester_score_sc_bas_id = data
  },
  SET_IS_ACTIVE(state, data) {
    state.is_active = data
  },
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search,
        score_type: context.state.score_type,
        monthly_score_sc_bas_id: context.state.monthly_score_sc_bas_id,
        semester_score_sc_bas_id: context.state.semester_score_sc_bas_id,
        is_active: context.state.is_active
      },
      attrubutes
    )
    return grade.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },

  store(context, data) {
    return grade.store(data)
  },

  update(context, data) {
    return grade.update(data)
  },
  destroy(context, id) {
    return grade.destroy(id)
  },
  getSubProgram(context, acp_id) {
    return grade.getSubProgram(acp_id)
  },

  getLevel(context, acp_id) {
    return grade.getLevel(acp_id)
  },

  getSubject(context, params) {
    return grade.getSubject(params)
  },

  getGrade(context, acps_id) {
    return grade.getGrade(acps_id)
  },

  getAcademicCorePrograms(context) {
    return grade.getAcademicCorePrograms()
  },

  nextGrade(context, data) {
    return grade.nextGrade(data)
  },

  async find(context, id) {
    if (_.isEmpty(context.state.edit_data)) {
      let response = await grade.find(id)
      context.commit('SET_EDIT_DATA', response.data)
    }
  },

  async dataBeforeCreate(context) {
    if (!context.state.edit_data.length > 0) {
      let coreProgram = await grade.getAcademicCorePrograms();
      context.commit('SET_CORE_PROGRAMS', coreProgram.data)
    }
    if (!context.state.main_programs.length > 0) {
      let response = await grade.getMainProgram()
      context.commit('SET_MAIN_PROGRAMS', response.data)
    }
    if (!context.state.ignore_cycle.length > 0) {
      let response = await grade.getIgnoreCycle()
      context.commit('SET_IGNORE_CYCLES', response.data)
    }

  },
}
